var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExams(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 2H3.625C3.19402 2 2.7807 2.14048 2.47595 2.39052C2.1712 2.64057 2 2.97971 2 3.33333V12.6667C2 13.0203 2.1712 13.3594 2.47595 13.6095C2.7807 13.8595 3.19402 14 3.625 14H13.375C13.806 14 14.2193 13.8595 14.524 13.6095C14.8288 13.3594 15 13.0203 15 12.6667V3.33333C15 2.97971 14.8288 2.64057 14.524 2.39052C14.2193 2.14048 13.806 2 13.375 2H10.125M5.25 2V8L7.6875 6L10.125 8V2M5.25 2H10.125",
    stroke: "#05B97D",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExams);
export default __webpack_public_path__ + "static/media/exams.5055bc3128eee152ba586450151ecdf9.svg";
export { ForwardRef as ReactComponent };